import React from "react";
import ReactDOM from "react-dom";
function Modal({
  title,
  icon,
  message,
  actions,
  className,
  submessage,
  open = false,
}) {
  // const [isOpen, setIsOpen] = React.useState(false);
  if (!open) return null;
  return ReactDOM.createPortal(
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center ${
        !open ? "hidden" : ""
      }`}
      style={{ zIndex: 5000 }} // Set a high z-index value
    >
      <div
        className={`bg-white rounded-lg p-8 w-96 max-h-80vh overflow-y-auto ${className}`}
      >
        <img src={icon} alt="modal icon" className="mx-auto w-40 h-40" />
        <h1 className="text-2xl font-semibold mb-4 text-center">
          {title == null ? "" : title.toString().toUpperCase()}
        </h1>
        <div className="text-center">{message}</div>
        <p className="mt-2 text-center font-bold">{submessage}</p>
        <hr className=""></hr>
        <div className="w-2/3 mx-auto my-4 min-w-4/5">{actions}</div>
      </div>
    </div>,
    document.body
  );
}

export default Modal;
